(function(){
  'use strict';
  if(window.MsofasHelpAnalytics)return;
  const cfg=window.MsofasHelpAnalyticsConfig||{};
  if(cfg.enabled!==true||cfg.preview||window.Shopify?.designMode)return;
  if(/[?&](preview_theme_id|preview_key)=/.test(location.search)||location.hostname.endsWith('.shopifypreview.com'))return;
  const endpoint=cfg.endpoint||'/apps/msofas-analytics/help';
  if(!/^\/(?!\/)[a-zA-Z0-9/_-]+$/.test(endpoint))return;
  const KEY='msofas:help:visitor:v1',PENDING='msofas:help:revocations:v1';
  const ttl=30*86400000,uuid=s=>typeof s==='string'&&/^[a-f0-9-]{36}$/i.test(s);
  const get=k=>{try{return JSON.parse(localStorage.getItem(k)||'null');}catch{return null;}};
  const put=(k,v)=>{try{v===null?localStorage.removeItem(k):localStorage.setItem(k,JSON.stringify(v));}catch{}};
  const allowed=()=>{try{const p=window.Shopify?.customerPrivacy;return p?.analyticsProcessingAllowed?.()===true&&p?.currentVisitorConsent?.().analytics==='yes';}catch{return false;}};
  let visitor=null,view=null,seconds=0,depth=0,epoch=0,busy=false,last=performance.now(),interaction=last,wasActive=false,sent=-1,sequence=0,blocked=false,nextAttempt=0;
  const pendingValues=()=>{const value=get(PENDING);return Array.isArray(value)?value.filter(uuid):[];};
  const pending=new Set(pendingValues());
  async function request(path,body){
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
    try{return await fetch(endpoint+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),
      credentials:'same-origin',keepalive:true,signal:controller.signal});}catch{return null;}finally{clearTimeout(timer);}
  }
  function rememberRevocation(id){if(uuid(id)){pending.add(id);put(PENDING,[...pending]);}}
  async function retryRevocations(){
    for(const id of [...pending]){
      const result=await request('/revoke',{visitor:id});
      if(result?.ok){pending.delete(id);put(PENDING,pending.size?[...pending]:null);}
    }
  }
  function stop(){
    const saved=get(KEY);
    rememberRevocation(visitor||saved?.id);
    epoch++;visitor=null;view=null;seconds=0;depth=0;wasActive=false;sent=-1;
    put(KEY,null);void retryRevocations();
  }
  function syncConsent(){
    if(!allowed()){
      wasActive=false;
      if(window.Shopify?.customerPrivacy?.currentVisitorConsent?.()?.analytics==='no'&&(visitor||get(KEY)))stop();
      return false;
    }
    return true;
  }
  function active(now){return document.visibilityState==='visible'&&document.hasFocus()&&now-interaction<60000;}
  function start(now){
    if(blocked||view||!cfg.page||!active(now))return;
    if(!uuid(visitor)){
      const saved=get(KEY);
      visitor=uuid(saved?.id)&&saved.expires>Date.now()&&!pending.has(saved.id)?saved.id:crypto.randomUUID();
      put(KEY,{id:visitor,expires:saved?.id===visitor?saved.expires:Date.now()+ttl});
    }
    view=crypto.randomUUID();seconds=0;depth=0;sent=-1;last=now;interaction=now;wasActive=true;
    void flush();
  }
  function measureDepth(){
    if(!cfg.page?.startsWith('article:'))return;
    const article=document.querySelector('.article-content .article-body')||document.querySelector('.article-content');
    if(!article)return;
    const r=article.getBoundingClientRect();
    if(r.height>0&&r.top<window.innerHeight&&r.bottom>0)
      depth=Math.max(depth,Math.min(100,Math.max(0,Math.floor((window.innerHeight-r.top)/r.height*100))));
  }
  function tick(){
    const now=performance.now(),delta=Math.max(0,now-last);last=now;
    if(!syncConsent())return;
    start(now);
    const current=active(now);
    // Count only continuous visible, focused time; sleeping/throttled tabs cannot add a long gap.
    if(view&&current&&wasActive&&delta<=2500){seconds=Math.min(3600,seconds+delta/1000);measureDepth();}
    wasActive=current;
    if(view&&Math.floor(seconds)-sent>=15)void flush();
  }
  async function flush(){
    if(blocked||busy||!view||!allowed()||performance.now()<nextAttempt)return;
    const currentEpoch=epoch,serial=++sequence;
    const body={id:view,visitor,page:cfg.page,seconds:Math.floor(seconds),depth};
    busy=true;
    const result=await request('/event',body);
    if(serial===sequence)busy=false;
    if(currentEpoch!==epoch)return;
    if(result?.ok){sent=body.seconds;nextAttempt=0;}
    else nextAttempt=performance.now()+15000;
    // A different tab may already have revoked this identity.
    if(result?.status===403){blocked=true;stop();}
    if(result?.status===422)blocked=true;
  }
  function touch(){interaction=performance.now();}
  document.addEventListener('visitorConsentCollected',()=>{blocked=false;nextAttempt=0;syncConsent();tick();});
  for(const event of ['pointerdown','keydown','scroll','touchstart'])window.addEventListener(event,touch,{passive:true,capture:event==='scroll'});
  window.addEventListener('focus',()=>{touch();last=performance.now();wasActive=false;});
  window.addEventListener('blur',()=>{wasActive=false;void flush();});
  document.addEventListener('visibilitychange',()=>{
    if(document.visibilityState!=='visible'){wasActive=false;void flush();}
    else {last=performance.now();touch();}
  });
  window.addEventListener('pagehide',()=>{wasActive=false;void flush();});
  window.addEventListener('pageshow',()=>{last=performance.now();touch();tick();});
  window.addEventListener('online',()=>{void retryRevocations();void flush();});
  window.addEventListener('storage',event=>{
    if(event.key===KEY||event.key===PENDING){
      for(const id of pendingValues())pending.add(id);
      if(visitor&&(pending.has(visitor)||get(KEY)?.id!==visitor)){epoch++;visitor=null;view=null;sent=-1;wasActive=false;}
      syncConsent();
    }
  });
  window.MsofasHelpAnalytics={version:'0.4.0'};
  setInterval(tick,1000);
  setInterval(()=>{void retryRevocations();},60000);
  void retryRevocations();
  if(window.Shopify?.customerPrivacy)tick();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)tick();});
})();
